<p-drawer 
  [(visible)]="visible" 
  position="right"
  [modal]="true" 
  [closable]="false"
  [showCloseIcon]="false"
  [style]="{ width: '60vw' }"
  styleClass="asset-history-drawer"
  (onHide)="closeModal()">
  
  <ng-template pTemplate="header">
    <div class="history-modal-header">
      <div class="header-left">
        <i class="pi pi-history header-icon"></i>
        <span class="header-title">History</span>
      </div>
      
      <div class="header-right">
        <!-- Pagination -->
        <div class="pagination-controls" *ngIf="totalRecords > 0">
          <span class="pagination-text">
            {{ offset + 1 }} - {{ Math.min(offset + limit, totalRecords) }} of {{ totalRecords }}
          </span>
          <div class="pagination-buttons">
            <button 
              pButton 
              icon="pi pi-chevron-left" 
              class="p-button-rounded p-button-text text-white"
              [disabled]="offset === 0"
              (click)="onPageChange({ first: offset - limit, rows: limit })">
            </button>
            <button 
              pButton 
              icon="pi pi-chevron-right" 
              class="p-button-rounded p-button-text text-white"
              [disabled]="offset + limit >= totalRecords"
              (click)="onPageChange({ first: offset + limit, rows: limit })">
            </button>
          </div>
        </div>

        <!-- Custom Close Button -->
        <button 
          pButton 
          icon="pi pi-times" 
          class="p-button-rounded p-button-text text-white close-btn"
          (click)="closeModal()">
        </button>
      </div>
    </div>
  </ng-template>

  <div class="history-modal-content">
    <!-- Loading State -->
    <div class="history-loading" *ngIf="isLoading">
      <i class="pi pi-spin pi-spinner" style="font-size: 2rem;"></i>
      <p>Loading history...</p>
    </div>

    <!-- Empty State -->
    <div class="history-empty" *ngIf="!isLoading && historyItems.length === 0">
      <i class="pi pi-inbox" style="font-size: 3rem; color: var(--surface-400);"></i>
      <p>No history records found</p>
    </div>

    <!-- History Table -->
    <div class="history-table-container" *ngIf="!isLoading && historyItems.length > 0">
      <div class="history-table-header">
        <div class="col-user">User Role</div>
        <div class="col-action">Action</div>
        <div class="col-remarks">Remarks</div>
        <div class="col-ref">Ref.ID</div>
      </div>

      <div class="history-items">
        <div class="history-item" *ngFor="let item of historyItems">
          <div class="col-user">
            <div class="user-info">
              <span class="user-name">{{ item.user_name }}</span>
              <span class="user-role" *ngIf="item.user_role || item.user_dept">
                ({{ item.user_role || item.user_dept }})
              </span>
            </div>
            <div class="event-datetime mt-1">
              <span class="event-date">{{ formatDate(item.event_date) }}</span>
              <span class="separator mx-1">|</span>
              <span class="event-time">{{ formatTime(item.event_date) }}</span>
            </div>
          </div>

          <div class="col-action">
            <span class="action-text">{{ item.action }}</span>
          </div>

          <div class="col-remarks">
            <span class="remarks-text" [pTooltip]="item.remarks" tooltipPosition="top">
              {{ item.remarks || '-' }}
            </span>
          </div>

          <div class="col-ref">
            <span class="ref-id">{{ item.reference_id || '-' }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</p-drawer>
